import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { isLoggedIn, selectToken } from "../login/loginSlice";
import { changeBankName, changeConfirmingBankUpdate, changeSavingsRate, changeTellerDepositPermission, changeTellerTransferPermission, changeTellerWithdrawalPermission, editModeActive, loadBankSettings, selectBankSettings, selectConfirmingBankUpdate, toggleCheckingActive, toggleEditMode, toggleSavingsActive, updateBankSettings } from "./bankSettingsSlice";

import './ManageBankSettings.css';

import Sidebar from "../../components/sidebar/Sidebar";
import ConfirmAction from "../../components/confirmAction/ConfirmAction";
import { selectUser } from "../home/userSlice";

export default function ManageBankSettings() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const token = useSelector(selectToken);

    const loggedIn = useSelector(isLoggedIn);
    const editModeIsActive = useSelector(editModeActive);
    
    const bankSettings = useSelector(selectBankSettings);
    const confirmingBankUpdate = useSelector(selectConfirmingBankUpdate);

    const userInfo = useSelector(selectUser);
    const userRole = userInfo.userRole;
    const bankId = userInfo.bankId;

    useEffect(() => {
        if (!loggedIn) {
            navigate('../login');
        }
    }, [navigate, loggedIn])

    useEffect(() => {
        if (userRole === 'ADMIN') {
            dispatch(loadBankSettings({bankId, token}));
        }
    }, [dispatch, userRole, bankId, token])

    const handleEditModeButtonClick = () => {
        dispatch(toggleEditMode());
    }

    const handleBankNameChange = (event) => {
        dispatch(changeBankName(event.target.value))
    }

    const handleCheckingActiveClick = () => {
        dispatch(toggleCheckingActive(!bankSettings.checkingActive));
    }

    const handleSavingsActiveClick = () => {
        dispatch(toggleSavingsActive(!bankSettings.savingsActive));
    }

    const handleSavingsRateChange = (event) => {
        dispatch(changeSavingsRate(event.target.value));
    }

    const handleTellerDepositPermissionChange = () => {
        dispatch(changeTellerDepositPermission(!bankSettings.tellerDepositPermission));
    }

    const handleTellerWithdrawalPermissionChange = () => {
        dispatch(changeTellerWithdrawalPermission(!bankSettings.tellerWithdrawalPermission));
    }

    const handleTellerTransferPermissionChange = () => {
        dispatch(changeTellerTransferPermission(!bankSettings.tellerTransferPermission));
    }

    const handleSaveClick = () => {
        dispatch(changeConfirmingBankUpdate(true));
    }

    const handleConfirmUpdateClick = () => {
        dispatch(updateBankSettings({newBankSettings: bankSettings, token}));
        dispatch(toggleEditMode());
        dispatch(changeConfirmingBankUpdate(false))
    }

    const handleConfirmCancelClick = () => {
        dispatch(changeConfirmingBankUpdate(false));
    }

    return (
        <main>
            <Sidebar />
            <section className="manage-bank-settings">
                <h2>Bank Settings</h2>
                <button onClick={handleEditModeButtonClick}>{editModeIsActive ? "Cancel" : "Edit Mode"}</button>
                <div>
                    <h3>General Settings</h3>
                    <div id="setting">
                        <h4>Bank Name:</h4>
                        {!editModeIsActive ? <p> {bankSettings.bankName}</p> :
                            <label htmlFor="bankName">
                                <input onChange={handleBankNameChange} value={bankSettings.bankName}></input>
                            </label>}
                    </div>
                </div>
                <div>
                    <h3>Checking Account Settings</h3>
                    <div id="setting">
                        <h4>Checking Accounts:</h4>
                        {!editModeIsActive ? <p>{bankSettings.checkingActive ? "Yes" : "No"}</p> : 
                            <label className="switch">
                                <input type="checkbox" onChange={handleCheckingActiveClick} checked={bankSettings.checkingActive}></input>
                                <span className="slider round"></span>
                            </label>}
                    </div>
                </div>
                <div>
                    <h3>Savings Account Settings</h3>
                    <div id="setting">
                        <h4>Savings Accounts:</h4>
                        {!editModeIsActive ? <p>{bankSettings.savingsActive ? "Yes" : "No"}</p> :
                            <label className="switch">
                                <input type="checkbox" onChange={handleSavingsActiveClick} checked={bankSettings.savingsActive}></input>
                                <span className="slider round"></span>
                            </label>}
                    </div>
                    {!bankSettings.savingsActive ? "" : 
                        <div id="setting">
                            <h4>Interest Rate:</h4>
                            {!editModeIsActive ? <p>{bankSettings.savingsRate}%</p> :
                                <label>
                                    <input onChange={handleSavingsRateChange} value={bankSettings.savingsRate}></input>
                                </label>}
                        </div>}
                </div>
                <div>
                    <h3>Teller Permissions</h3>
                    <div id="setting">
                        <h4>Deposits:</h4>
                        {!editModeIsActive ? <p>{bankSettings.tellerDepositPermission ? "Yes": "No"}</p> : 
                            <label className="switch">
                                <input type="checkbox" onChange={handleTellerDepositPermissionChange} checked={bankSettings.tellerDepositPermission}></input>
                                <span className="slider round"></span>
                            </label>
                        }
                    </div>
                    <div id="setting">
                        <h4>Withdrawals:</h4>
                        {!editModeIsActive ? <p>{bankSettings.tellerWithdrawalPermission ? "Yes" : "No"}</p> :
                            <label className="switch">
                                <input type="checkbox" onChange={handleTellerWithdrawalPermissionChange} checked={bankSettings.tellerWithdrawalPermission}></input>
                                <span className="slider round"></span>
                            </label>
                        }
                    </div>
                    <div id="setting">
                        <h4>Transfers:</h4>
                        {!editModeIsActive ? <p>{bankSettings.tellerTransferPermission ? "Yes" : "No"}</p> :
                            <label className="switch">
                                <input type="checkbox" onChange={handleTellerTransferPermissionChange} checked={bankSettings.tellerTransferPermission}></input>
                                <span className="slider round"></span>
                            </label>
                        }
                    </div>
                </div>
                {editModeIsActive ? <button onClick={handleSaveClick}>Save Changes</button> : ""}
                {confirmingBankUpdate ? <ConfirmAction handleConfirm={handleConfirmUpdateClick} handleCancel={handleConfirmCancelClick}/> : ""}
            </section>
        </main>
    )
}